import { render, staticRenderFns } from "./LightBulbIcon.vue?vue&type=template&id=742c4948"
import script from "./LightBulbIcon.vue?vue&type=script&lang=js"
export * from "./LightBulbIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports